module.exports = {"430112001":"高塘岭街道","430112003":"丁字湾街道","430112005":"大泽湖街道","430112006":"月亮岛街道","430112007":"白沙洲街道","430112008":"金山桥街道","430112009":"黄金园街道","430112011":"乌山街道","430112012":"铜官街道","430112013":"雷锋街道","430112101":"桥驿镇","430112103":"茶亭镇","430112106":"靖港镇","430112107":"乔口镇","430112115":"白箬铺镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430112.json
// module id = 1657
// module chunks = 0